export var IngestionPipelineErrorLevel;
(function (IngestionPipelineErrorLevel) {
    IngestionPipelineErrorLevel["INGESTION_PIPELINE_ERROR_LEVEL_ERROR"] = "ERROR";
    IngestionPipelineErrorLevel["INGESTION_PIPELINE_ERROR_LEVEL_WARN"] = "WARN";
})(IngestionPipelineErrorLevel || (IngestionPipelineErrorLevel = {}));
